import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { Drawer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import menuTree, { menuTreeWholesale } from 'config/menuTree';

import ListMenu from './components/ListMenu';
import MenuFooter from './components/MenuFooter';

import buildMenuTree from './buildMenuTree';
import useDealerProducts from 'hooks/useDealerHasProducts';

import { Container, Overlay, styles } from './styles';

function DashListBuilder(props) {
  const { classes, open, handleDrawerOpen, hiddeMenuAndHeaderItens } = props;

  const { currentDealer } = useSelector(state => state.dealerStore);
  const { currentGroup } = useSelector(state => state.callCenter);

  const { hasProduct } = useDealerProducts();

  const { userType, userProfile, profiles, email } = useSelector(
    state => state.userStore
  );

  const [menuTreeFiltred, setMenuTree] = useState([]);

  const parseMenuTree = useCallback(async () => {
    const products = currentDealer?.products;

    try {
      setMenuTree([]);

      const menuTreeTemp = hasProduct('PORTAL_ATACADO')
        ? menuTreeWholesale(currentDealer.id, currentDealer?.website)
        : menuTree(currentDealer.id, currentDealer?.website);

      const menuTreeFiltred = buildMenuTree(
        menuTreeTemp,
        products,
        userType,
        userProfile,
        profiles,
        email,
        currentDealer?.financingBancoPanEnabled,
        currentDealer.groupId
      );

      setMenuTree(menuTreeFiltred);
    } catch (e) {
      setMenuTree([]);
    }
  }, [
    userType,
    profiles,
    currentDealer.id,
    currentGroup?.id,
    window.location.pathname,
  ]);

  useEffect(() => {
    parseMenuTree();
  }, [userType, profiles, currentDealer.id, window.location.pathname]);

  // * ON CONSULTANT SCREEN /myreselers
  if (hiddeMenuAndHeaderItens) return <div />;

  return (
    <DashList
      {...props}
      classes={classes}
      open={open}
      menuTree={menuTreeFiltred}
      handleDrawerOpen={handleDrawerOpen}
      currentDealer={currentDealer}
    />
  );
}

const DashList = ({
  classes,
  open,
  handleDrawerOpen,
  menuTree,
  currentDealer,
  ...props
}) => {
  return (
    <Drawer
      variant="permanent"
      anchor="left"
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
      open={open}
    >
      <Container>
        <div
          className={classes.toolbar}
          style={{ position: 'relative', minHeight: '74px' }}
        ></div>
        <Overlay />

        <div className={classes.drawerBody}>
          <ListMenu
            menuTree={menuTree}
            level={0}
            open={open}
            {...props}
            handleDrawerOpen={handleDrawerOpen}
            currentDealer={currentDealer}
          />
        </div>
        <MenuFooter isOpened={open} />
      </Container>
    </Drawer>
  );
};

export default withStyles(styles)(DashListBuilder);
